/**
 * @file コンポーネント：利用規約確認モーダル DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Modal } from "~/src/components/projects/Modal";
import { Terms } from "~/src/components/projects/Terms";
import { Headline } from "~/src/components/uiparts/Headline";
import { Paragraph } from "~/src/components/uiparts/Paragraph";

// スタイル読み込み
import {
    StyledContent,
    StyledContentHeader,
    StyledContentHeaderLogo,
    StyledContentHeaderLogoImage,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <Modal
            buttonlist={[
                {
                    buttonType: "submit",
                    disabled: !props.isAgreed,
                    onClick: (e) => props.fnSendTermsAgreed(e),
                    text: localized["Label.Send"],
                },
            ]}
            content={[
                <StyledContent key="terms">
                    <StyledContentHeader>
                        <StyledContentHeaderLogo>
                            <StyledContentHeaderLogoImage
                                alt={localized["Title.Home"]}
                                height="18"
                                src="/assets/images/logo.png"
                                width="90"
                            />
                        </StyledContentHeaderLogo>
                        <Headline
                            fontSize="small"
                            onColor="white"
                            tag="h3"
                            text={localized["Label.HeadlineCheckTerms"]}
                            textAlign="center"
                        />
                        <Paragraph
                            fontSize="xSmall"
                            onColor="white"
                            text={localized["Label.DescriptionCheckTerms"]}
                            textAlign="center"
                        />
                    </StyledContentHeader>
                    <Terms
                        frameScroll={true}
                        hasAgreeCheck={true}
                        isAgreed={props.isAgreed}
                        onColor="white"
                        setIsAgreed={props.setIsAgreed}
                    />
                </StyledContent>,
            ]}
            hasButtonClose={false}
            isShow={props.isShow}
            setIsShow={() => void {}}
        />
    );
};
